<template>
    <div class="card mt-3 mb-4">
        <div class="card-header">
            Online Drivers <span class="badge badge-success">{{ onlineDriverCount }}</span> <small>(Total: {{ drivers.length}})</small>
        </div>
        <div class="card-body p-0">
            <loader v-if="loading"></loader>
            <div id="driverList" v-else>
                <b-table sort-by="status" :sort-desc="true" small striped hover :fields="['status', 'name', 'surname']" :items="drivers">
                    <template v-slot:cell(name)="{item}">
                        <router-link :to="{ name: 'userDetail', params: { id: item.id }}">{{item.name}}</router-link>
                    </template>
                    <template v-slot:cell(surname)="{item}">
                        <router-link :to="{ name: 'userDetail', params: { id: item.id }}">{{item.surname}}</router-link>
                    </template>
                    <template v-slot:cell(status)="{item}" >
                        <div class="text-center">
                            <b-icon scale="5" v-if="item.status" icon="dot" variant="success"></b-icon>
                            <b-icon scale="5" v-else icon="dot" variant="secondary"></b-icon>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
    </div>

</template>

<script>
    import GetUsers from "../../../../store/actions/getUsers";
    import ContentLoader from "../../../../components/ContentLoader";
    import ShowError from "../../../../helpers/showError";
    const driverSchema = (driver, status = false) => ({id: driver.id, name: driver.name, surname: driver.surname, status});

    export default {
        name: 'DriverStatusComponent',
        data: () => ({
            loading: false,
            fields: [
                {
                    key: 'id',
                    label: 'id',
                },
                {
                    key: 'name',
                    label: 'Name',
                },
                {
                    key: 'surname',
                    label: 'Surname',
                }
            ],
            search: {
                perPage: undefined,
                page: 1,
                name: undefined,
                surname: undefined,
                phoneNumber: undefined,
                group: 3,
                isReady: true,
                fields: ['id', 'name', 'surname', 'phoneNumber', 'groups', 'createdAt']
            },
            drivers: [],
            onlineDrivers: []
        }),
        computed: {
          onlineDriverCount() {
              return this.drivers.filter(driver => driver.status).length;
          }
        },
        components: {
            loader: ContentLoader
        },
        sockets: {
            DRIVER_OFFLINE: function({userId}) {
                this.changeDriverStatus(userId, false);
            },
            DRIVER_ONLINE: function({user}) {
                this.changeDriverStatus(user.id, true);
            }
        },
        methods: {
            async getAllDrivers() {
                try {
                    this.loading = true;
                    const {data: drivers} = await GetUsers(this.search);
                    this.drivers = drivers.map(driver => driverSchema(driver));
                    this.$attrs.onlineDrivers.forEach(({user}) => {
                        this.changeDriverStatus(user.id, true)
                    });
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            },
            changeDriverStatus(userId, status) {
                const userIndex = this.drivers.findIndex(driver => driver.id === userId);
                if (userIndex > -1) {
                    this.$set(this.drivers[userIndex], 'status', status)
                }
            }
        },
        async created() {
            await this.getAllDrivers();
        }
    }
</script>

<style scoped>
    #driverList {
        height: 500px;
        overflow: scroll;
    }
</style>